import React, { useEffect, useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  Image,
  TextInput,
} from "react-native";
import ManageAdvert from "./manageAdvert";
import * as DocumentPicker from "expo-document-picker";
import { apiservice } from "../service/api";
import { useRecoilValue } from "recoil";
import { tokenState } from "../reducer";
import { addImage } from "../utils";

const { width, height } = Dimensions.get("window");

const addAdvert = ({ setPages, state }) => {
  const data1 = [{ data1 }, { data1 }, { data1 }, { data1 }];
  const [page, setpage] = useState(0);
  const [image, setImage] = useState({});
  const token = useRecoilValue(tokenState);

  async function pickup() {
    const res = await addImage();

    setBody((val) => ({ ...val, image_url: res }));
  }

  useEffect(() => {
    if (state.id != undefined) {
      setBody(state);
    }
  }, [state]);

  const [body, setBody] = useState({
    name: "",
    image_url: [""],
    link: "",
  });

  async function createadv() {
    const res = await apiservice({
      path: state.id ? "/adv/update" : "/adv/create",
      method: "post",
      body,
      token: token.accessToken,
    });

    if (res.status == 200) {
      setBody({
        name: "",
        image_url: "",
        link: "",
      });
      setPages(0);
    }
  }

  return (
    <View style={styles.container}>
      {page == 0 && (
        <View
          style={{
            width: width * 0.82,
            height: height * 0.9,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Text
            style={{
              width: width * 0.591,
              fontSize: 18,
              fontFamily: "Prompt-Regular",
              color: "#202020",
            }}
          >
            เพิ่มโฆษณา
          </Text>

          <View
            style={{
              borderWidth: 0.5,
              borderColor: "#002377",
              width: width * 0.591,
              margin: 30,
            }}
          ></View>

          <View style={{ width: width * 0.591, height: height * 0.546 }}>
            {body.image_url != undefined ? (
              <Image
                resizeMode={"stretch"}
                source={{ uri: body.image_url }}
                style={{
                  width: 200,
                  height: 200,
                  borderWidth: 0.5,
                  borderRadius: 5,
                  marginVertical: 15,
                }}
              />
            ) : (
              <View
                style={{
                  width: 200,
                  height: 200,
                  borderWidth: 0.3,
                  borderRadius: 5,
                  borderColor: "#00237750",
                  marginVertical: 15,
                }}
              />
            )}

            <View
              style={{
                width: width * 0.235,
                height: height * 0.037,
                flexDirection: "row",
              }}
            >
              <TextInput
                style={{
                  width: width * 0.8,
                  height: height * 0.037,
                  borderTopLeftRadius: 5,
                  borderBottomLeftRadius: 5,
                  borderWidth: 1,
                  overflow: "hidden",
                  borderColor: "#00237740",
                  paddingLeft: 5,
                  fontFamily: "Prompt-Regular",
                  fontSize: 12,
                }}
                value={body.image_url}
                onChangeText={(text) => {
                  setBody((val) => ({
                    ...val,
                    image_url: text,
                  }));
                }}
              />
              <TouchableOpacity
                onPress={() => {
                  pickup();
                }}
                style={{
                  width: width * 0.05,
                  height: height * 0.037,
                  backgroundColor: "#002377",
                  borderTopRightRadius: 5,
                  borderBottomRightRadius: 5,
                }}
              >
                <Text
                  style={{
                    fontSize: 16,
                    fontFamily: "Prompt-Regular",
                    color: "#ffff",
                    margin: "auto",
                  }}
                >
                  อัพโหลดรูป
                </Text>
              </TouchableOpacity>
            </View>

            <View
              style={{
                width: width * 0.591,
                height: height * 0.037,
                flexDirection: "row",
                justifyContent: "space-between",
                marginVertical: 15,
              }}
            >
              <View style={styles.Boxarea}>
                <Text style={styles.Text18}>ชื่อโฆษณา</Text>
                <TextInput
                  value={body.name}
                  onChangeText={(text) => {
                    setBody((val) => ({
                      ...val,
                      name: text,
                    }));
                  }}
                  style={styles.TextInput}
                />
              </View>
              <View style={styles.Boxarea}>
                <Text style={styles.Text18}>Link</Text>
                <TextInput
                  value={body.link}
                  onChangeText={(text) => {
                    setBody((val) => ({
                      ...val,
                      link: text,
                    }));
                  }}
                  style={styles.TextInput}
                />
              </View>
            </View>

            <View style={styles.Boxareabutton}>
              <TouchableOpacity
                onPress={createadv}
                style={{
                  width: 100,
                  height: 40,
                  borderRadius: 5,
                  backgroundColor: "#69D443",
                  marginRight: 20,
                }}
              >
                <Text style={styles.TextButton}>ยืนยัน</Text>
              </TouchableOpacity>

              <TouchableOpacity
                onPress={() => setpage(1)}
                style={{
                  width: 100,
                  height: 40,
                  borderRadius: 5,
                  backgroundColor: "#D44343",
                }}
              >
                <Text style={styles.TextButton}>ยกเลิก</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      )}
      {page == 1 && <ManageAdvert />}
    </View>
  );
};
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#ffff",
  },
  Boxarea: {
    width: width * 0.25,
    height: height * 0.037,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  Boxareabutton: {
    width: width * 0.297,
    height: height * 0.037,
    flexDirection: "row",
    alignItems: "center",
    marginVertical: 15,
  },
  Text18: { fontSize: 18, fontFamily: "Prompt-Regular" },
  TextInput: {
    width: width * 0.182,
    height: height * 0.037,
    borderWidth: 0.5,
    borderColor: "#00237740",
    borderRadius: 5,
    paddingLeft: 10,
    fontSize: 18,
    fontFamily: "Prompt-Regular",
  },
  TextButton: {
    fontSize: 16,
    color: "#ffff",
    margin: "auto",
    fontFamily: "Prompt-Regular",
  },
});

export default addAdvert;
